import makeStyles from '@mui/styles/makeStyles';

export const useTranslationStyles = makeStyles(() => ({
  tableWrapper: {
    paddingTop: 24,
    width: "55vw",
    "@media(max-width: 960px)": {
      width: "80vw",
    },

    "& .MuiTableContainer-root": {
      overflowY: "hidden",
    },
  },
}));
